import React, { SetStateAction } from 'react';

import openToIcon from 'images/directory/opento_icon.svg';

import { CheckBoxGroup } from '@components/FormFields';
import { FilterOptionsResponse } from '@utils/backend-api/subscriber_directory';
import { FilterOption as FilterOptionType } from '@utils/backend-api/subscriber_directory';

import FilterOption from './FilterOption';
import { ShowFilterMap } from './Layout';

interface FilterNavProps {
  handleResetForm: () => void;
  openToOptions: FilterOptionType[];
  setDisplayedFilterOptions: (option: SetStateAction<FilterOptionsResponse>) => void;
  setShowFilterMap: (showFilterMap: SetStateAction<ShowFilterMap>) => void;
  setShowSlideFilter: (showSlideFilter: boolean) => void;
  showFilterMap: ShowFilterMap;
  showSlideFilter: boolean;
}

const FilterNav = ({ openToOptions, setShowFilterMap, showFilterMap }: FilterNavProps) => {
  return (
    <div className="FilterNav">
      <FilterOption
        fieldName="openTo"
        icon={openToIcon}
        input={<CheckBoxGroup name="openTo" options={openToOptions} />}
        label="Interested In"
        setShowFilterMap={setShowFilterMap}
        showFilter={showFilterMap['openTo']}
      />
    </div>
  );
};
export default FilterNav;
